/**
 * EquipmentTable — таблица для камер типа EQUIPMENT.
 * Тонкая обёртка над FramesTableBase с набором колонок для страницы "Оборудование".
 */
import React from "react";
import FramesTableBase, { formatDateTime, getShiftByTime } from "../../components/FramesTableBase/FramesTableBase";

const STORAGE_KEY = "equipmentTable_columns_v2";

const EQUIPMENT_COLUMNS = [
  {
    key: "date",
    label: "Дата",
    render: (frame, _shifts, timezone) => formatDateTime(frame.created_at, frame.display_timezone || timezone),
    filterType: "date",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "shift",
    label: "Смена",
    render: (frame, shifts, timezone) => getShiftByTime(frame.created_at, shifts, frame.display_timezone || timezone),
    filterType: "shift",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "signal",
    label: "Тип сигнала",
    render: (frame) => frame.signal_type ?? "—",
    filterType: "text",
    filterKey: "signal_type",
    defaultVisible: true,
    hideable: true,
  },
  {
    key: "brightness",
    label: "Уровень яркости",
    render: (frame) => frame.light_brt ?? "—",
    filterType: null,
    defaultVisible: true,
    hideable: true,
  },
];

const EquipmentTable = (props) => (
  <FramesTableBase
    {...props}
    columns={EQUIPMENT_COLUMNS}
    storageKey={STORAGE_KEY}
  />
);

export default EquipmentTable;
